<template>
  <div class="battery-bd tb" v-if="funcView.battery_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- <el-form-item style="float: right;" v-if="funcView.export">
          <el-button class="table-set" style="vertical-align: top;" @click="exportTable('modemBatteryExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item> -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('dms_battery.ModemSNdian_chiSN')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-radio-group style="float: right; margin-right: 8px" v-model="formSearch.testState" @change="onPageChange({ page: 1 })">
          <el-radio-button :label="item.value" v-for="(item, index) in testStateData" :key="index">{{ item.name }}</el-radio-button>
        </el-radio-group>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item label="IMSI">
          <el-input v-model="formSearch.imsi" placeholder="" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item label="ICCID">
          <el-input v-model="formSearch.iccid" placeholder="" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item label="IMEI">
          <el-input v-model="formSearch.simImei" placeholder="" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_battery.xie_yi')">
          <el-input v-model="formSearch.protocolCode" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_battery.sheng_yu_dian_liang')">
          <!-- <el-input v-model="formSearch.batteryCharge" placeholder="" style="width:100%;"></el-input> -->
          <input-range v-model="formSearch.batteryCharge" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('dms_battery.geng_xin_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.dataTimes" type="daterange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :index="true" :data="tableList" :column="tableColumn" :loading="isLoading" @sort="sortChange" @filter="filterChange" :slots="['modemSn', 'protocolCode', 'action','networkType','cellularMode','dbm']">
        <template slot="modemSn" slot-scope="scope">
          <span
            v-if="funcView.battery_modem_detail"
            class="cell-link"
            @click="
              jump('/redirect/boarddetail', {
                deviceId: scope.row.deviceId,
                type: 'battery',
                testType: formSearch.testType,
                modemSn: scope.row.modemSn,
                batterySn: scope.row.batterySn,
                parentPath: $route.path,
              })
            "
          >
            {{ scope.row.modemSn }}
          </span>
          <span v-else>{{ scope.row.modemSn }}</span>
        </template>
        <template slot="protocolCode" slot-scope="scope">
          <span>{{ scope.row.protocolCode || '-' }}/{{ scope.row.tcpVersion || '-' }}</span>
        </template>
        <template v-slot:networkType="scope">
          <div v-if="`${scope.row.isOnline}` === '1'">{{ getDicValue('dms_device_network_type', scope.row.networkType) || '-'  }}</div>
          <div v-else>{{ '-' }}</div>
        </template>
        <template v-slot:cellularMode="scope">
          <div v-if="`${scope.row.isOnline}` === '1'">{{ getDicValue('dms_device_cellular_mode', scope.row.cellularMode) || '-'}}</div>
          <div v-else>{{ '-' }}</div>
        </template>
        <template v-slot:dbm="scope">
          <div v-if="`${scope.row.isOnline}` === '1'">{{ scope.row.dbm || '-' }}</div>
          <div v-else>{{ '-' }}</div>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" v-if="`${scope.row.websiteState}` === '1' && funcView.battery_edit" @click="onEdit(scope.row)">{{ funcView.battery_edit }}</el-button>
          <el-button type="text" size="mini" v-if="['0', '100'].includes(formSearch.testState) && funcView.battery_test && scope.row.batterySn" @click="onTesting(scope.row)">
            {{ funcView.battery_test }}
          </el-button>
          <el-button type="text" size="mini" v-if="`${scope.row.testState}` === '10' && !scope.row.bodyNum && funcView.battery_init" @click="onInit(scope.row)">{{ funcView.battery_init }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 测试 -->
    <device-test-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></device-test-dialog>
    <!-- 编辑 -->
    <batteryItem-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTableList"></batteryItem-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import inputRange from '@/components/inputRange';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import deviceTestDialog from '@/pages/dms/components/device_test_dialog.vue';
import batteryItemDialog from './children/battery_Item_dialog.vue';

export default {
  mixins: [resetFormSearchMixins],
  name: 'battery',
  components: {
    deviceTestDialog,
    inputRange,
    batteryItemDialog,
  },
  computed: {
    testStateData() {
      if (!this.propertyMap.dms_test_state) {
        return [];
      }
      return this.propertyMap.dms_test_state.filter((i) => i.code !== 'confirming');
    },
  },
  data() {
    return {
      provide: true,
      tableCode: 'factoryTest_battery',
      formSearch: {
        testState: '0',
        testType: '1', // 测试类型:1-电池，9-整机
        search: '',
        orderBy: '',
        orderType: '',
        imsi: '',
        iccid: '',
        simImei: '',
        pageSize: 50,
        pageNum: 1,
        protocolCode: '',
        beginOfModified: '',
        endOfModified: '',
        dataTimes: '',
        batteryCharge: [],
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      link: null,
      isLoading: false,
    };
  },
  activated: function () {
    this.getTableList();
  },
  mounted: function () {
    this.isLoading = true;
    this.getDictionary('dms_test_state');
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
  },
  methods: {
    // 获取列表
    getTableList() {
      this.isLoading = true;
      this.tableList = [];
      this.formSearch.beginOfModified = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.endOfModified = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.formSearch.beginOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[0] : '';
      this.formSearch.endOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[1] : '';
      this.$getJSON(apis.modemBatteryPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 测试
    onTesting(row) {
      this.dialogModel.title = this.$t('dms_battery.dian_chi_ce_shiSNo', [row.batterySn]);
      this.dialogModel.data = row;
      this.dialogModel.data.testType = this.formSearch.testType;
      this.dialogVisible = true;
    },
    // 编辑
    onEdit(row) {
      this.dialogModel2.title = this.$t('Common.com_edit');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.data = row;
      this.dialogVisible2 = true;
    },
    onInit: function (row) {
      const tips = this.$t('dms_battery.nqdjsxdccxszwdcs');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.modemBatteryInit}/${row.modemBatteryId}`, {}, true).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
